import { COMPANY_TERMS_AND_CONDITIONS } from "constants/assets";

export const HELP_CENTER = "https://help.hellopaid.com";
export const HELP_EMAIL = "help@hellopaid.com";
export const TERMS_AND_CONDITIONS = COMPANY_TERMS_AND_CONDITIONS;
export const PRIVACY_POLICY = "https://hellopaid.com/terms-and-privacy-policy";
export const PAYMENT_PLAN_SCHEDULE = "https://calendly.com/keep-team/pick-a-payment-plan";
export const CONFIGURE_REPAYMENT_LOAN_SCHEDULE =
  "https://calendly.com/keep-team/pick-a-payment-plan";
